module.exports = __webpack_public_path__ + "static/media/accountSlug.ffba5c1c.svg";